import { makeEnum } from 'services/store/utils-actions';

export const path = 'user';

export const types = makeEnum(
  'SET_USER',
);
